import Box from "@material-ui/core/Box";
import React, { useState } from "react";
import readFile from "../../../utils/readFile";

const Photo = ({ photo, active, activePhotoIndex }) => {
  const [file, setFile] = useState<string>("");
  
  if (photo.file instanceof File) {
    readFile(photo.file).then(setFile);
  } else if (typeof photo.file === "string") {
    setFile(photo.file);
  }
  
  return (
    <Box
      sx={{
        backgroundImage: "url(" + file + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
        width: 56.5,
        height: 56.5,
        border: ({ colors }) => {
          if (active === false) {
            return undefined;
          }
          return "3px solid " + colors.primary.main;
        },
        transition: "all .5s",
        boxSizing: "border-box",
        cursor: active ? undefined : "pointer",
      }}
      onClick={() => activePhotoIndex(photo.index)}
    >
    </Box>
  );
};

export default Photo;
